export default function getRequiredToReadOptions() {
  return [
    {
      labelKey: 'optional',
      value: false,
      leftIcon: 'import_contacts',
    },
    {
      labelKey: 'must-be-read',
      value: true,
      leftIcon: 'import_contacts',
    },
  ];
}
